module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/alliance/footer/footer.component.scss
// module id = ./src/app/shared-components/alliance/footer/footer.component.scss
// module chunks = main